import createRoutine from '@/utils/createRoutine'

export const opportunityRoutine = createRoutine('opportunityRoutine')
export const seeMoreRoutine = createRoutine('seeMoreRoutine')

export const opportunityGetters = {
  OPPORTUNITY_LIST: 'OPPORTUNITY_LIST'
}

export const seeMoreGetters = {
  SEE_MORE: 'SEE_MORE'
}

export const OPPORTUNITY_CLEANUP = 'OPPORTUNITY_CLEANUP'
export const SEE_MORE_CLEANUP = 'SEE_MORE_CLEANUP'
